import openedgeTokensTemplate from './openedgeTokens.html'

/*******************************************************************************
 * @ngdoc    component
 * @module   csm.books.OurOrg
 * @name     csm.books.OurOrg.component:openedgeTokens
 * @constructor
 * @param {object=} apiTokens    Open Edge processor tokens.
 * @param {string}  defaultName  Default account name = `xWebID-terminalID`.
 * @description
 * Takes input of OpenEdge processor tokens.
 *******************************************************************************/
export const openedgeTokensComponent = {
  template: openedgeTokensTemplate,
  bindings: { apiTokens: '<', defaultName: '=' },
  controller: openedgeTokensController
}

/* @ngInject */ function openedgeTokensController($scope) {
  const $ctrl = this;
  const setName = (nv) =>
    ($ctrl.defaultName = `${nv.xWebID || ''}-${nv.terminalID || ''}`);
  $scope.$on('destroy', $scope.$watch('$ctrl.apiTokens', setName, true));
}